import { render, staticRenderFns } from "./ProductCombosForm.vue?vue&type=template&id=379b87c0"
import script from "./ProductCombosForm.vue?vue&type=script&lang=ts"
export * from "./ProductCombosForm.vue?vue&type=script&lang=ts"
import style0 from "./ProductCombosForm.vue?vue&type=style&index=0&id=379b87c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports